import { ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import Typography from './typography';
import theme from './custom-theme';
import { useBrandContext } from 'context/BrandProvider';

type Props = {
  children: ReactNode;
};

const ThemeProvider = ({ children }: Props) => {
  const { colors } = useBrandContext();
  return (
    <StyledThemeProvider theme={{ ...theme, colors }}>
      <Typography />
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
